module.exports = __webpack_public_path__ + "static/overview-phone-cdc2faed183892423c7512f81ef2446f.png";